import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { accountService } from "../services/accountService";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { RegisterUser } from "../models/Account";
import Warning from "./Warning";
import { GoogleLogin } from "@react-oauth/google";

const Register = ({ setUser }: { setUser: Function }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [invalid, setInvalid] = useState<string>();

  const validatePassword = (pwd: string) => {
    let count = 0;
    if (/.{8,}/.test(pwd)) count++; // min 8 znaków
    if (/[A-Z]/.test(pwd)) count++; // wielka litera
    if (/[a-z]/.test(pwd)) count++; // mała litera
    if (/[0-9]/.test(pwd)) count++; // cyfra
    if (/[!@#$%^&*(),.?":{}|<>]/.test(pwd)) count++; // znak specjalny

    if (count < 3) return "Hasło musi spełniać co najmniej 3 z 5 kryteriów: długość, wielka litera, mała litera, cyfra, znak specjalny";
    return null;
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setInvalid(undefined);

    if (!username) return (setInvalid("Uzupełnij nazwę użytkownika"), setIsSubmitting(false));
    if (!email) return (setInvalid("Uzupełnij email"), setIsSubmitting(false));
    if (!password) return (setInvalid("Uzupełnij hasło"), setIsSubmitting(false));
    if (!confirmPassword) return (setInvalid("Uzupełnij potwierdzenie hasła"), setIsSubmitting(false));
    if (!acceptTerms) return (setInvalid("Zaakceptuj regulamin"), setIsSubmitting(false));

    const pwdError = validatePassword(password);
    if (pwdError) return (setInvalid(pwdError), setIsSubmitting(false));

    if (password !== confirmPassword) return (setInvalid("Hasło musi się zgadzać"), setIsSubmitting(false));

    try {
      const register: RegisterUser = { name: username, email, password };
      await accountService.register(register);
      navigate("/login");
    } catch (error: any) {
      setIsSubmitting(false);
      setInvalid("Nie udało się zarejestrować. Spróbuj ponownie.");
    }
  };

  const handleGoogleRegister = async (credentialResponse: any) => {
    setIsSubmitting(true);
    try {
      const token = credentialResponse.credential;
      const user = await accountService.registerWithGoogle(token);
      setUser(user);

      const from = (location.state as any)?.from?.pathname;
      if (from && from !== "/register" && from !== "/login") {
        navigate(from, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    } catch (error) {
      setInvalid("Nie udało się zarejestrować przez Google");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Form onSubmit={onSubmit} className="shadow-box" style={{ width: 400, maxWidth: "100%", margin: "auto" }}>
      <FormGroup>
        <Input
          onChange={(e) => setUsername(e.target.value.trim())}
          placeholder="Nazwa użytkownika"
          type="text"
          name="username"
          id="username"
          autoComplete="username"
          required
        />
      </FormGroup>
      <FormGroup>
        <Input
          onChange={(e) => setEmail(e.target.value.trim())}
          placeholder="Email"
          type="email"
          name="email"
          id="email"
          autoComplete="email"
          required
        />
      </FormGroup>
      <FormGroup>
        <Input
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Hasło"
          type="password"
          name="password"
          id="password"
          autoComplete="new-password"
          required
        />
      </FormGroup>
      <FormGroup>
        <Input
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Potwierdź hasło"
          type="password"
          name="confirmPassword"
          id="confirmPassword"
          autoComplete="new-password"
          required
        />
      </FormGroup>
      <FormGroup check className="mb-3">
        <Input
          onChange={() => setAcceptTerms(!acceptTerms)}
          type="checkbox"
          name="acceptTerms"
          id="acceptTerms"
          required
        />
        <Label for="acceptTerms" check>
          Znam i akceptuję{" "}
          <Link to="/terms">Regulamin</Link> oraz <Link to="/policyterm">Politykę Prywatności</Link>{" "}
          <span style={{ color: "red" }}>*</span>
        </Label>
      </FormGroup>

      {invalid && <Warning>{invalid}</Warning>}

      {isSubmitting ? (
        <div className="spinner" />
      ) : (
        <>
          <Button className="single-btn w-100 mb-2" type="submit" disabled={isSubmitting}>
            Zarejestruj
          </Button>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <GoogleLogin
              onSuccess={handleGoogleRegister}
              onError={() => setInvalid("Nie udało się zarejestrować przez Google")}
            />
          </div>
        </>
      )}
    </Form>
  );
};

export default Register;
